<template>
    <div class="story">
        <div class="banner">
            <Carousel :slides="banners"></Carousel>
        </div>

        <StoryAbstract class="abstract" :item="story.abstract"></StoryAbstract>

        <StoryDetail :storyDetail="story.detail"></StoryDetail>

        <PastStories :past-stories="pastStories"></PastStories>
    </div>
</template>

<script>
    import Carousel from '../components/common/Carousel'
    import StoryAbstract from '../components/container/story/StoryAbstract'
    import StoryDetail from '../components/container/story/StoryDetail'
    import PastStories from '../components/container/story/PastStories'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'seriesDetail',
        components: {
            Carousel,
            StoryAbstract,
            StoryDetail,
            PastStories,
        },
        computed: {
            ...mapState('storyDetail', {
                banners: ({banners}) => {
                    return banners.map((banner, index) => {
                        return {
                            isPic: banner.type === 'pic',
                            isVideo: banner.type === 'video',
                            video: {
                                ref: 'allSeries' + index,
                                videoSrc: banner.src_file,
                                loop: true,
                                muted: true,
                                autoplay: true,
                            },
                            imgSrc: banner.src_file,
                            width: 1680,
                            height: 600,
                        }
                    })
                },
                story: ({story}) => {
                    let abstract = story.abstract

                    let detail = story.detail.map(item => {
                        let banners = []

                        if (item.acf_fc_layout === 'pics') {
                            banners = item.gallery.map(img => {
                                return {
                                    isPic: true,
                                    imgSrc: img,
                                    isVideo: false,
                                    video: {}
                                }
                            })
                        }

                        if (item.acf_fc_layout === 'video') {
                            banners = [
                                {
                                    isPic: false,
                                    isVideo: true,
                                    video: {
                                        ref: 'storyVideo',
                                        videoSrc: item.video,
                                        loop: true,
                                        muted: true,
                                        autoplay: true,
                                    }
                                }
                            ]
                        }


                        return {
                            type: item.acf_fc_layout,
                            text: item.text,
                            banners,
                        }
                    })

                    return {
                        abstract: abstract,
                        detail: detail,
                    }
                },
                pastStories: ({pastStories}) => {
                    const lang = localStorage.getItem('lang') || 'cn'

                    let items = pastStories.map(story => {
                        return {
                            parentPath: '/stories/',
                            slug: story.slug,
                            imgSrc: story.cover_pic,
                            name: story.title,
                            desc: story.excerpt,
                            link: lang === 'cn' ? '查看此项' : 'View Story',
                            url: '',
                        }
                    })

                    return {
                        title: lang === 'cn' ? 'Dovetail 往期故事' : 'SELECTED STORIES FOR YOU',
                        items: items
                    }
                }
            })
        },
        methods: {
            ...mapActions('storyDetail', ['getPageInfo'])
        },
        watch: {
            '$route' () {
                //this.getPageInfo(this.$route.params.id)
                location.reload()
            }
        },
        created() {
            this.getPageInfo(this.$route.params.id)
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .series-container {
        margin-top: 100px;
    }

    .abstract {
       /deep/ .title {
            padding-bottom: 0;
        }
    }
</style>
